<template>
  <div class="message-item">
    <div :class="sentByUser ? 'user-message message-body' : 'message-body'">
      <p>{{ message.body }}</p>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    sentByUser() {
      return this.message.senderKey.userId === this.$store.state.user.userId;
    },
  },
  props: ["message"],
};
</script>
<style scoped>
.message-item {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.message-body {
  max-width: 60%;
  width: fit-content;
  text-align: left;
  filter: drop-shadow(0px 1px 1px var(--shadow));
  background-color: var(--secondaryColor);
  padding: 12px;
  border-radius: 0px 10px 10px 10px;
  margin: 5px;
}

.user-message {
  margin-left: auto;
  background-color: #bcffed;
  border-radius: 10px 10px 0px 10px;
  align-self: right;
}

.read-note {
  text-align: right;
  margin: 0;
  font-size: 8px;
}
p {
  margin: 0;
  font-size: 0.75rem;
  font-weight: 600;
}
</style>
